<template>
  <div class="modal fade"
       id="modal-create-unit"
       tabindex="-1"
       role="dialog"
       data-bs-backdrop="static"
       data-bs-keyboard="false">
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white">
          <h5 class="modal-title">{{ unit ? 'Modifier l’Unité' : 'Ajouter une Unité' }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fermer"></button>
        </div>

        <div class="modal-body">
          <ValidationObserver ref="observer" v-slot="{ invalid }">
            <form @submit.prevent="submitForm">
              <div class="form-row">
                <div class="form-group col-md-6 mb-0">
                  <ValidationProvider
                      name="Code"
                      rules="required|min:2|max:5"
                      v-slot="{ errors }"
                      :custom-messages="{
                      min: 'Le code doit contenir au moins 2 caractères.',
                      max: 'Le code doit contenir au plus 5 caractères.'
                    }"
                  >
                    <label class="form-label">Code <span class="text-danger">*</span></label>
                    <input
                        v-model="payload.code"
                        type="text"
                        :disabled="isEdit"
                        @input="payload.code = (payload.code || '').toUpperCase()"
                        class="form-control"
                        placeholder="Entrer code..."
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </div>

                <div class="form-group col-md-6 mb-0">
                  <ValidationProvider name="Label" rules="required" v-slot="{ errors }">
                    <label class="form-label">Nom de l’unité <span class="text-danger">*</span></label>
                    <input
                        v-model="payload.label"
                        @input="payload.label = (payload.label || '').toUpperCase()"
                        type="text"
                        class="form-control"
                        placeholder="Ex: Pièce, Kg, Litre..."
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </div>
              </div>

              <div class="text-end mt-4">
                <button type="button" class="btn btn-gray me-2" data-bs-dismiss="modal">Annuler</button>
                <button type="submit" class="btn btn-success" :disabled="invalid">
                  <i class="fe fe-check"></i> {{ unit ? 'Modifier' : 'Créer' }}
                </button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { confirmAction, showValidationErrors } from "../../helpers/helpers";

  export default {
    name: "ModalCreateUnit",
    props: {
      unit: { type: Object, default: null },
    },
    data() {
      return {
        payload: { code: "", label: "" },
      };
    },
    computed: {
      // Réactif selon la prop
      isEdit() {
        return !!this.unit;
      },
    },
    watch: {
      // Hydrate/clear le formulaire selon ouverture en edit/create
      unit: {
        immediate: true,
        handler(newVal) {
          if (newVal) {
            this.payload = {
              code: newVal.code || "",
              label: newVal.label || "",
            };
          } else {
            this.resetForm();
          }
        },
      },
    },
    methods: {
      resetForm() {
        this.payload = { code: "", label: "" };
        if (this.$refs.observer) this.$refs.observer.reset();
      },

      async submitForm() {
        const isValid = await this.$refs.observer.validate();
        if (!isValid) return;

        const { confirmed } = await confirmAction(this.isEdit ? "edit" : "create");
        if (!confirmed) return;

        this.$loading(true);
        const req = this.isEdit
            ? this.$http.put(`/registry/units/${this.unit.code}`, this.payload)
            : this.$http.post("/registry/units", this.payload);

        req
            .then(() => {
              this.$toast?.success(this.isEdit ? "Unité modifiée avec succès." : "Unité créée avec succès.");
              this.$emit("refresh");
              // Ferme et reset
              $("#modal-create-unit").modal("hide");
              this.resetForm();
            })
            .catch((err) => {
              console.error(err);
              showValidationErrors(err);
            })
            .finally(() => this.$loading(false));
      },
    },
    mounted() {
      // Reset automatique quand la modale se ferme (croix/Annuler/extérieur)
      $("#modal-create-unit").on("hidden.bs.modal", () => this.resetForm());
    },
    beforeDestroy() {
      $("#modal-create-unit").off("hidden.bs.modal");
    },
  };
</script>
